var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCaptainIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 110 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".CaptainIcon-1{fill:#ffffff;}.CaptainIcon-2{fill:#2edaff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "CaptainIcon-1",
  d: "M55.17,4.2l-9.69,21.66c-.24,.53,.15,1.13,.73,1.13h3.97s4.99-3.1,4.99-3.1l4.99,3.1h3.97c.58,0,.97-.6,.73-1.13L55.17,4.2Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "CaptainIcon-2",
  points: "46.32 15.43 24.35 15.43 33.63 20.54 44.04 20.54 46.32 15.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "CaptainIcon-2",
  points: "49.52 8.28 11.35 8.28 20.63 13.39 47.24 13.39 49.52 8.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "CaptainIcon-2",
  points: "60.81 8.28 63.1 13.39 90.22 13.39 98.98 8.28 60.81 8.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "CaptainIcon-2",
  points: "66.3 20.54 77.95 20.54 86.72 15.43 64.01 15.43 66.3 20.54"
}))));
export default SvgCaptainIcon;